import React from 'react';
import { PropTypes } from "prop-types";
import { Row } from 'antd';
import { MainWrapper, TitleWrap, ContentWrap, ShowMoreButton, Wrapper } from './styles';
import downArrow from "../../../../../../assets/icons/short-arrow-b-green.svg";
import { ImageWrap } from "../../../Step2LegacyOptions/Components/AccordionContent/styles";
import { connect } from "react-redux";
import { Percentage, Check } from "../../../Step2LegacyOptions/Components/LegacyAccordions/styles";
import AccordionContent from "../AccordionContent/AccordionContent";
import { shouldShowMore } from "../../../actions";
import {  ContentDiv } from "../../../../../../CommonComponents/commonStyles";
import { recordError } from "../../../../../../utils/commonUtil";
import { basicLegacy, basicTempData } from '../../../DefaultPropTypes';
import { LegacyAccordionDerivedStates } from '../../../selectors';

export class LegacyAccordions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      display: "none",
      showMoreButtonDisplayButton: true
    }
  }

  handleShowMore = () => {
    try {
      let id = document.getElementById(this.props.contentKey);
      id.style.display = "block";
      this.setState({
        display: "block",
        showMoreButtonDisplayButton: false
      })
    } catch (error) {
      recordError(error);
    }
  }

  handleShowLess = (e) => {
    e.stopPropagation();
    let id = document.getElementById(this.props.contentKey);
    id.style.display = "none";
    id.scrollIntoView(0);
    this.setState({
      display: "none",
      showMoreButtonDisplayButton: true
    })
  }

  toggleContainer = () => {
    try {
      let id = document.getElementById(this.props.contentKey);
      if(this.state.showMoreButtonDisplayButton){
        id.style.display = "block";
        this.setState({
          display: "block",
          showMoreButtonDisplayButton: false
        })
      }else{
        id.style.display = "none";
        id.scrollIntoView(0);
        this.setState({
          display: "none",
          showMoreButtonDisplayButton: true
        })
      }
    } catch (error) {
      recordError(error);
    }
  }

  getPercentage = (arr) => {
      let percentage = "";
      arr.forEach(val => {
        if(val.optionId === this.props.contentKey) {
          percentage = val.percentage
        }
      })
      if(percentage === "") {
        return 0
      } else {
        return percentage;
      }
      
    }
  render() {
    let w = window.innerWidth;
    let percent = this.getPercentage(this.props.tempData.tempJSON.legacyOptions);
    return (
      <div>
      <Row>
          <MainWrapper role="main">
            <Wrapper onClick={this.toggleContainer}>
              <div>
              <TitleWrap dangerouslySetInnerHTML={{__html: this.props.title}} />
              {
          w <= 769 ? <Percentage marginRight="60px" textColor="#022737">{percent}%</Percentage> : null
        }{
          this.state.showMoreButtonDisplayButton ? 
          <ContentDiv><ContentWrap marginBottom="30px" dangerouslySetInnerHTML={{__html: this.props.subTitle}} /></ContentDiv>:
          <ContentDiv><ContentWrap marginBottom="0" dangerouslySetInnerHTML={{__html: this.props.subTitle}} /></ContentDiv>
        }
              
              {
                this.state.showMoreButtonDisplayButton ? 
                <ShowMoreButton onClick={this.handleShowMore} id={"btnShowMore"+this.props.contentKey}>
        Show More <ImageWrap src={downArrow}  alt="Down Arrow" />
      </ShowMoreButton> : null
              }
              
      </div>
      <div>
      {
          w > 769 ? <Percentage marginRight="60px" textColor="#022737">{percent}%</Percentage> : null
        }
        </div>
        </Wrapper>
        <Check displayType={this.state.display} id={"chk"+this.props.contentKey}>
        <AccordionContent handleShowLess={(e) => this.handleShowLess(e)} contentKey={this.props.contentKey} percentage={this.props.percentage} />
        </Check>
          </MainWrapper>
      </Row>
  </div>
    )
  }
 }

const mapStateToProps = state => ({
    legacy: state.getIn(["npaFormReducer", "legacyOptions", "legacyOptions", "legacyOptions"]),
    ...LegacyAccordionDerivedStates(state.toJS())
});

const mapDispatchToProps = dispatch => ({
  shouldShowMore: val => dispatch(shouldShowMore(val))
})

LegacyAccordions.propTypes = {
  contentKey: PropTypes.number,
  legacy: basicLegacy,
  percentage: PropTypes.string,
  shouldShowMore: PropTypes.func,
  showMore: PropTypes.any,
  subTitle: PropTypes.string,
  tempData: basicTempData,
  title: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(LegacyAccordions);